import React from 'react'
import styled from '@emotion/styled'

const withStyle = (WrappedTimerBoxEditor) => {
  const StyledTimerBoxEditor = styled(WrappedTimerBoxEditor)(
    (props) => `
      font-size: 12px;
    `
  )

  return (props) => <StyledTimerBoxEditor {...props} />
}

export default withStyle
